import React from 'react'
import MaterialSymbol from '../material-symbol'

const FilterList = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="filter_list" {...props} />
))

FilterList.displayName = 'FilterList'

export default FilterList
